export default __webpack_public_path__ + "static/media/kaminfeuer_web-lg@1x.c09e0c23.jpg";